export default __webpack_public_path__ + "static/takeaway-points-2-0271a491678ca72308480966065125f2.png";